export default __webpack_public_path__ + "static/media/hht2_ep13_timeline_q02_b.8458eeb6.png";